import $ from 'jquery';




function changeNames() {


    // $(".wpb_category > li > ul > li.cat-item > a").each(function (i, e) {
    //     var str = $(e).html();
    //     if (str.indexOf(" – ") >= 0) {
    //         var res = str.replace(" – ", "<span class='sep'></span>");
    //         console.log(res);

    //         var exp = '<span class="wpb-submenu-indicator">+</span>';
    //         $(this).html(res);
    //     }
    // });


    $(document).ready(function () {
        $(".wpb_category_n_menu_accordion_list > li > ul > .cat-item > a").each(function (i, e) {
            var str = this.innerText;


            str = str.replace('+', '');



            console.log(str);



            /*
            var titleArray = str.split(" – ");

            console.log(titleArray);
            var div = this;

            var children = [];

            var res = '';
            var titlenum = document.createElement('span');
            var title = document.createElement('span');
            var exp = document.createElement('span');
            titlenum.className = 'title-num';
            title.className = 'title-text';
            exp.className = 'title-exp';


            var text = document.createTextNode(titleArray[0]);
            titlenum.append(text);
            children.push(titlenum);


            children.push(div.children[0]);



            text = document.createTextNode(titleArray[1]);
            title.append(text);
            children.push(title);

            title.append(text);

            children.push(div.children[1]);



            div.innerHTML = "";
            children.forEach(function (item) {
                div.appendChild(item);
            });

            */

            //             var insMe = document.getElementsByClassName('cat-item-857')[0];
            // insMe.childNodes[1].innerHTML = '';

            // insMe[0].innerHTML = "Line 1\r\nLine2";

            // $(e).html($(e).html().replace($(e).text(),''));

            // if (str.indexOf(" – ") >= 0) {
            //     var res = str.replace(" – ", exp);
            //     var res = "<span class='tab'>" + str.replace(str, "<span>" + str + "</span class='title'>") + "</span>";
            //     //        
            //     // res = exp;
            //     console.log(res);
            //     // this.innerHTML= res+"1212";
            //     // $(this).text("res");

            // }
        });
    });

    $(document).ready(function () {
        // })
        $(".children .cat-item-have-child li.cat-item > a").each(function (i, e) {
            var str = $(e).html();
            if (str.indexOf(" – ") >= 0 && str.indexOf(" ") >= 0) {
                var res = "<span class='tab'>" + str.replace(" – ", "</span><span class='title'>") + "</span>";
                // console.log(res);
                $(this).html(res);
            }
        });
    })
}



function removeText(element) {
    var newElement = $('<' + element[0].nodeName + '/>');
    for (i = 0; i < item.attributes.length; i++) {
        newElement.attr(item.attributes[i].name, item.attributes[i].value);
    }
    element.children().each(function () {
        newElement.append(this);
    });
    element.replaceWith(newElement);
}





export function initSidebar() {
    changeNames();
    console.log('initSidebar');
}



